import { Container } from "../../components/FormPreviewer/Container";
import { Form } from "../../components/FormPreviewer/Form";
import { Previewer } from "../../components/FormPreviewer/Previewer";
import { Canvas } from "./Canvas";
import { AddonForm } from "./Forms/AddonForm";
import { UpsellForm } from "./Forms/UpsellForm";
import { UpsellTabProviderContext } from "./UpsellTabContext";

export const UpsellTab = () => (
  <UpsellTabProviderContext>
    <Container>
      <Form>
        <UpsellForm />
        <AddonForm />
      </Form>
      <Previewer>
        <Canvas.EmptyState />
      </Previewer>
    </Container>
  </UpsellTabProviderContext>
);
